import { Award, Bell, BookOpen, Building, Calendar, Flower2, Gift, HelpCircle, Hotel, IdCard, LucideIcon, MapPin, MessageSquareHeart, PhoneCall, Settings, Sparkles, Star, Tv2, Wifi } from 'lucide-react';

import { KbSection } from '@/views/AiAgents/queries';

/**
 * Metadane sekcji KB dla popover'a Stefana z checkboxami.
 * Ikony spójne z sidebarem panelu — admin widzi to samo co w
 * menu, mapping sekcja → strona jest oczywisty.
 */
export interface KbSectionMeta {
  icon: LucideIcon;
  labelKey: string;
  labelFallback: string;
}

export const KB_SECTION_META: Record<KbSection, KbSectionMeta> = {
  hotelInfo: { icon: Hotel, labelKey: 'stefan.sections.hotelInfo', labelFallback: 'Informacje hotelowe' },
  amenities: { icon: Flower2, labelKey: 'stefan.sections.amenities', labelFallback: 'Udogodnienia' },
  outlets: { icon: Settings, labelKey: 'stefan.sections.outlets', labelFallback: 'Punkty usługowe' },
  products: { icon: Gift, labelKey: 'stefan.sections.products', labelFallback: 'Produkty i usługi' },
  attractions: { icon: MapPin, labelKey: 'stefan.sections.attractions', labelFallback: 'Atrakcje w okolicy' },
  businessCards: { icon: IdCard, labelKey: 'stefan.sections.businessCards', labelFallback: 'Wizytówki' },
  events: { icon: Calendar, labelKey: 'stefan.sections.events', labelFallback: 'Wydarzenia' },
  specialOffers: { icon: Sparkles, labelKey: 'stefan.sections.specialOffers', labelFallback: 'Oferty specjalne' },
  goodPractices: { icon: BookOpen, labelKey: 'stefan.sections.goodPractices', labelFallback: 'Dobre praktyki' },
  phoneBook: { icon: PhoneCall, labelKey: 'stefan.sections.phoneBook', labelFallback: 'Książka telefoniczna' },
  wifi: { icon: Wifi, labelKey: 'stefan.sections.wifi', labelFallback: 'WiFi' },
  rules: { icon: Bell, labelKey: 'stefan.sections.rules', labelFallback: 'Regulaminy' },
  tvChannels: { icon: Tv2, labelKey: 'stefan.sections.tvChannels', labelFallback: 'Kanały TV' },
  faq: { icon: HelpCircle, labelKey: 'stefan.sections.faq', labelFallback: 'FAQ' },
  loyalty: { icon: Award, labelKey: 'stefan.sections.loyalty', labelFallback: 'Program lojalnościowy' },
  socialMedia: { icon: MessageSquareHeart, labelKey: 'stefan.sections.socialMedia', labelFallback: 'Social media' },
  virtualTour: { icon: Building, labelKey: 'stefan.sections.virtualTour', labelFallback: 'Wirtualny spacer' },
  reviews: { icon: Star, labelKey: 'stefan.sections.reviews', labelFallback: 'Linki do recenzji' },
};
